import React from 'react';
import { useSelector } from 'react-redux';
import { RootState as C_RootState } from '@Redux/common/store';
import styles from '../style.module.scss';
import cN from 'classnames';
import Meals from './Meals';
import { timeTransform } from '@utils/utils';
interface I_Props {
    dailyItem: any;
    mealType: Array<number>;
    trafficIcon: { [key: string]: JSX.Element };
    toggleLightBox: (reqDayID: number, reqPOIID: string) => void;
}

const DayInclusions: React.FC<I_Props> = ({ dailyItem, mealType, toggleLightBox }) => {
    const { curPage } = useSelector((store: C_RootState) => store.pageReducer);
    return (
        <div className={styles.includsions}>
            {dailyItem.MealList.length > 0 && (
                <div className={styles.meal}>
                    <h3>餐食</h3>
                    <div>
                        {mealType.map((type, idx) => {
                            return (
                                <Meals
                                    key={`${type}`}
                                    mealList={dailyItem.MealList}
                                    mealTypes={type}
                                    DayID={dailyItem.DayID}
                                    toggleLightBox={toggleLightBox}
                                />
                            );
                        })}
                    </div>
                </div>
            )}
            {dailyItem.HotelList.length > 0 && (
                <div className={styles.hotel}>
                    <h3>旅館</h3>
                    <div>
                        {dailyItem.HotelList.map((item: any, idx: any) => (
                            <span
                                key={idx}
                                className={cN(
                                    item.HotelID && curPage !== 'print' && styles.trigger
                                )}
                                onClick={() =>
                                    item.HotelID &&
                                    curPage !== 'print' &&
                                    toggleLightBox(dailyItem.DayID, item.HotelID)
                                }
                            >
                                {item.Name}
                                {idx === dailyItem.HotelList.length - 1 ? '' : ' 或 '}
                            </span>
                        ))}
                    </div>
                </div>
            )}
            {dailyItem.TrafficList.length > 0 && (
                <div className={styles.traffic}>
                    <h3>交通</h3>
                    <div className={styles.trafficRight}>
                        {dailyItem.TrafficList.map((item: any, i: number) => {
                            return (
                                <div className={styles.trafficItem} key={i}>
                                    <div className={styles.trafficType}>
                                        <span>{item.TypeName}</span>
                                        <span
                                            className={cN('ic-ln', styles.icon, `${item.TypeIcon}`)}
                                        />
                                    </div>
                                    <div className={styles.trafficContent}>
                                        {(item.DistanceInfo || item.DrivingTime) && (
                                            <div className={styles.colon}>
                                                {item.DistanceInfo && `約${item.DistanceInfo} `}
                                                {item.DrivingTime &&
                                                    `時間約${timeTransform(item.DrivingTime)}`}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}

                        {dailyItem.CruiseList.length > 0 && (
                            <div className={styles.trafficItem}>
                                <div className={styles.trafficType}>
                                    <span>郵輪</span>
                                    <span className={cN('ic-ln icon icruise')} />
                                    ：&nbsp;
                                </div>
                                <div className={styles.trafficContent}>
                                    {dailyItem.CruiseList.map((item: any, idx: number) => (
                                        <div key={idx}>{`${item.Company}/${item.ShipName} ${
                                            idx === dailyItem.CruiseList.length - 1 ? '' : '或'
                                        }`}</div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DayInclusions;
